import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { ThirdPartyRegistrationFormVM } from './third-party-registration-form.viewmodel';
import { ThirdPartyRegistrationFormPresentation } from './third-party-registration-form.presentation';

interface IProps {
    vm: ThirdPartyRegistrationFormVM;
}

const ThirdPartyRegistrationFormContainer = withViewModel(
    ThirdPartyRegistrationFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { ThirdPartyRegistrationFormContainer as ThirdPartyRegistrationForm };
